import { render, staticRenderFns } from "./install.vue?vue&type=template&id=9b912b8a&scoped=true"
import script from "./install.vue?vue&type=script&lang=js"
export * from "./install.vue?vue&type=script&lang=js"
import style0 from "./install.vue?vue&type=style&index=0&id=9b912b8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b912b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b912b8a')) {
      api.createRecord('9b912b8a', component.options)
    } else {
      api.reload('9b912b8a', component.options)
    }
    module.hot.accept("./install.vue?vue&type=template&id=9b912b8a&scoped=true", function () {
      api.rerender('9b912b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/install.vue"
export default component.exports